import {
  Field,
  getAvailableFields,
} from 'shared/domain/visibleField/availableFields';
import { HashMap } from 'shared/types/commonView';

export function getAvailableFieldsMap(): HashMap<Field> {
  return getAvailableFields().reduce<HashMap<Field>>((result, field) => {
    result[field.fieldName] = field;
    return result;
  }, {});
}
